import Styled from 'styled-components';

import { commonInputStyles, IInputProps } from './InputCommon';

// tslint:disable:max-line-length
const secureIcon: string = `"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='32' viewBox='0 0 14 32'%3E%3Ctitle%3E secureBtn %3C/title%3E%3Cpath d='M12.727 15.08h-.513v-2.873l.001-.101a5.167 5.167 0 0 0-5.167-5.167l-.106.001-.096-.001a5.167 5.167 0 0 0-5.166 5.273v-.005 2.873h-.352a1.333 1.333 0 0 0-1.327 1.458v7.055c0 .81.657 1.467 1.467 1.467h11.067c.81 0 1.467-.657 1.467-1.467v-7.06l.001-.053c0-.73-.556-1.331-1.269-1.4zm-9.394 0v-3.133a3.54 3.54 0 0 1 7.08 0v3.133h-7.08z'/%3E%3C/svg%3E"`;
const dollarIcon: string = `"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3E%3Cg fill='none' stroke='%23444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M24 2v44M34.75 10C29.75 7.25 14 5.2 14 14.667 14 26 34 22 34 32s-13 9.25-22 6'/%3E%3C/g%3E%3C/svg%3E"`;
export const calendarIcon: string = `"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23A7B8C3' d='M15 2h-2V0h-2v2H9V0H7v2H5V0H3v2H1c-.553 0-1 .447-1 1v12c0 .553.447 1 1 1h14c.553 0 1-.447 1-1V3c0-.553-.447-1-1-1zm-1 12H2V6h12v8z'/%3E%3C/svg%3E"`;
// tslint:enable:max-line-length

const Input = Styled.input<IInputProps>`
  ${commonInputStyles}

  transition: border-color ease-in-out 0.15s;
  border-width: 1px;

  &:hover,
  &:focus {
    border: 1px solid ${({ theme: { input } }) => input.colorBorder};
    border-bottom-width: 2px;
    border-bottom-color: ${({ theme: { brand } }) => brand.colorSecondary};
    padding-bottom: calc(0.75em - 1px);
  }

  ${props => props.icon === 'secure' && `
    background-image: url(${secureIcon});
    background-repeat: no-repeat;
    padding-left: 2.5em;
    background-size: 20px 36px;
    background-position: 0.7em 0.25em;
  `}

  ${props => props.icon === 'dollar' && `
    padding-left: 1.75em;
    background-image: url(${dollarIcon});
    background-position: left 0.5em center;
    background-repeat: no-repeat;
    background-size: auto 15px;
  `}

  ${props => props.icon === 'calendar' && `
    background-image: url(${calendarIcon});
    padding-right: 2.75em;
    background-position: right 0.75em center;
    background-repeat: no-repeat;
    background-size: auto 50%;
  `}

  ${props => props.alert && `
    border: 1px solid ${props.theme.input.colorBorder};
    border-bottom-width: 2px;
    border-bottom-color: ${props.theme.brand.colorAlert};
    padding-bottom: calc(0.75em - 1px);

    &:hover,
    &:focus {
      border-bottom-color: ${props.theme.brand.colorAlert};
    }
  `}
`;

Input.defaultProps = {
  alert: false
};

Input.displayName = 'Input';

export default Input;
